import React from 'react'
import PropTypes from 'prop-types'
import getConfig from 'next/config'

const { CDN_URL } = getConfig().publicRuntimeConfig

const HomepageStructuredData = ({ hostname }) => (
  <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
          {
            "@context": "http://schema.org",
            "@type": "WebSite",
            "@name": "Ticketswap",
            "url": "https://${hostname}",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://${hostname}/search?query={search_term_string}",
                "query-input": "required name=search_term_string"
            }
          }
        `,
      }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
          {
            "@context": "http://schema.org",
            "@type": "Organization",
            "url": "http://www.ticketswap.com",
            "logo": "${CDN_URL}/static/images/facebook-image-squarable.png",
            "sameAs": [
                "https://www.facebook.com/TicketSwap",
                "https://www.twitter.com/TicketSwap",
                "https://www.instagram.com/ticketswap",
                "https://medium.com/ticketswap"
            ]
        }
        `,
      }}
    />
  </>
)

HomepageStructuredData.propTypes = {
  hostname: PropTypes.string.isRequired,
}

export default HomepageStructuredData
